module.exports = __webpack_public_path__ + "img/5-2.4b9d019e.png";